import React from "react";
// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from "universal-cookie";
import LoadingOverlay from "react-loading-overlay";
import Table from "../../widgets/tables/Table";
import WaitDialog from "../../widgets/WaitDialog";
import getLeads from "../../services/getLeads";
import getTag from "../../services/getTag";
import deleteLeads from "../../services/deleteLeads";
import getCategorieTag from "../../services/getCategorieTag";
import setLeadVisto from "../../services/setLeadVisto";
import { LeadsContext } from "../../context/LeadsContext";

export default class DaChiamare extends React.Component {
  static contextType = LeadsContext;
  constructor(props) {
    super(props);

    this.pageDiv = {
      border: "1px solid #cccccc",
      padding: 10,
    };

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    if (this.pageName == undefined) {
      this.pageName = this.section;
    }

    this.options = [{ value: "All", label: "All" }];

    this.selectRef = React.createRef();

    // Recupera i filtri salvati dal localStorage
    const getSavedFilters = () => {
      try {
        const savedSelectedTags = localStorage.getItem(
          "daChiamare_selectedTags"
        );
        const savedExcludedTags = localStorage.getItem(
          "daChiamare_excludedTags"
        );
        const savedDataInizio = localStorage.getItem("daChiamare_dataInizio");
        const savedDataFine = localStorage.getItem("daChiamare_dataFine");

        const filters = {
          selectedTags: savedSelectedTags ? JSON.parse(savedSelectedTags) : [],
          excludedTags: savedExcludedTags ? JSON.parse(savedExcludedTags) : [],
          dataInizio: savedDataInizio ? JSON.parse(savedDataInizio) : null,
          dataFine: savedDataFine ? JSON.parse(savedDataFine) : null,
        };

        console.log(
          "🔄 DaChiamare - Filtri recuperati dal localStorage:",
          filters
        );
        return filters;
      } catch (e) {
        console.error("❌ DaChiamare - Errore nel recupero dei filtri:", e);
        return {
          selectedTags: [],
          excludedTags: [],
          dataInizio: null,
          dataFine: null,
        };
      }
    };

    const savedFilters = getSavedFilters();

    this.grid = 2;
    this.pdfElements = [];
    this.studenti = [];
    this.pageTitle = "Da Chiamare";
    this.brokerId = undefined;

    const cookies = new Cookies();
    var strJson = JSON.stringify({ list: [] });
    cookies.set("checksList", strJson, { path: "/" });

    this.sendMailRef = React.createRef();
    this.sendNotificationRef = React.createRef();

    this.handleCategoriaChange = this.handleCategoriaChange.bind(this);
    this.handleCorsiChange = this.handleCorsiChange.bind(this);

    this.tags = [];

    // Stato unificato con i filtri salvati
    this.state = {
      testo: "",
      menuBackground: "#ffffff",
      menuItemColor: "#000000",
      fontSize: 50,
      fontBold: false,
      logoPicture: "",
      logoMargin: 0,
      titleColor: "#000000",
      titleSize: 18,
      isLoading: false,
      addElementVisible: false,
      waitDialogVisible: false,
      mailCompaniesList: [],
      leads: [],
      studenti: [],
      selectedTags: savedFilters.selectedTags,
      excludedTags: savedFilters.excludedTags,
      dataInizio: savedFilters.dataInizio,
      dataFine: savedFilters.dataFine,
    };
  }

  handleTagChange = (selectedTags) => {
    console.log("💾 DaChiamare - Salvataggio selectedTags:", selectedTags);
    localStorage.setItem(
      "daChiamare_selectedTags",
      JSON.stringify(selectedTags)
    );
    this.setState({ selectedTags: selectedTags }, () => {
      this.reload();
    });
  };

  handleDataInizioChange = (dataInizio) => {
    console.log("💾 DaChiamare - Salvataggio dataInizio:", dataInizio);
    localStorage.setItem("daChiamare_dataInizio", JSON.stringify(dataInizio));
    this.setState({ dataInizio: dataInizio }, () => {
      this.reload();
    });
  };

  handleDataFineChange = (dataFine) => {
    console.log("💾 DaChiamare - Salvataggio dataFine:", dataFine);
    localStorage.setItem("daChiamare_dataFine", JSON.stringify(dataFine));
    this.setState({ dataFine: dataFine }, () => {
      this.reload();
    });
  };

  handleTagRemoveChange = (removedTags) => {
    console.log("💾 DaChiamare - Salvataggio excludedTags:", removedTags);
    localStorage.setItem(
      "daChiamare_excludedTags",
      JSON.stringify(removedTags)
    );
    this.setState(
      {
        excludedTags: removedTags,
      },
      () => {
        this.reload();
      }
    );
  };

  handleResetFilters = () => {
    console.log(
      "🧹 DaChiamare - Reset completo di tutti i filtri e ordinamenti"
    );
    // Pulisce tutti i filtri dal localStorage
    localStorage.removeItem("daChiamare_selectedTags");
    localStorage.removeItem("daChiamare_excludedTags");
    localStorage.removeItem("daChiamare_dataInizio");
    localStorage.removeItem("daChiamare_dataFine");
    localStorage.removeItem("daChiamare_table_searchText");
    localStorage.removeItem("daChiamare_table_order");
    localStorage.removeItem("daChiamare_table_orderBy");
    localStorage.removeItem("daChiamare_table_page");

    // Resetta i filtri nello stato
    this.handleTagChange([]);
    this.handleTagRemoveChange([]);
    this.handleDataInizioChange("");
    this.handleDataFineChange("");
  };

  handleCategoriaChange(option) {
    this.setState({ selectedCategoria: option, selectedCorsi: null }, () => {
      this.reload();
    });
  }

  handleCorsiChange(option) {
    this.setState({ selectedCorsi: option }, () => {
      this.reload();
    });
  }

  async reload() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });

    this.leads = await getLeads(username, token);
    this.tags = await getTag(username, token);
    this.category = await getCategorieTag(username, token);

    const findCategoryTags = this.category.map((category) => {
      const tags = this.tags.filter((tag) => tag.id_categoria === category.id);
      return {
        ...category,
        tags,
      };
    });

    const excludeCategoryIds = [1, 5];

    const excludeTagIds = findCategoryTags
      .filter((category) => excludeCategoryIds.includes(category.id))
      .flatMap((category) => category.tags.map((tag) => tag.id));

    // Applica prima il filtro per escludere categorie specifiche
    const initialFilteredLeads = this.leads.filter((lead) => {
      const tagIds = lead.tag_id
        ? lead.tag_id.split(",").map((id) => parseInt(id))
        : [];
      const hasExcludedTag = tagIds.some((tagId) =>
        excludeTagIds.includes(tagId)
      );
      return !hasExcludedTag;
    });

    // Applica i filtri aggiuntivi (tag selezionati, tag esclusi, date)
    const filteredLeads = initialFilteredLeads.filter((lead) => {
      const tagIds = lead.tag_id
        ? lead.tag_id.split(",").map((tagId) => Number(tagId))
        : [];

      const dataCreazione = new Date(lead.data_creazione);

      // Filtro per data inizio
      if (this.state.dataInizio) {
        const dataInizio = new Date(this.state.dataInizio);
        if (dataCreazione < dataInizio) {
          return false;
        }
      }

      // Filtro per data fine
      if (this.state.dataFine) {
        const dataFine = new Date(this.state.dataFine);
        if (dataCreazione > dataFine) {
          return false;
        }
      }

      // Filtro per tag esclusi
      if (this.state.excludedTags && this.state.excludedTags.length > 0) {
        const excludedTagValues = this.state.excludedTags.map((tag) =>
          Number(tag.value)
        );
        if (tagIds.some((tagId) => excludedTagValues.includes(tagId))) {
          return false;
        }
      }

      // Filtro per tag selezionati (inclusivi)
      if (!this.state.selectedTags || this.state.selectedTags.length === 0) {
        return true;
      }

      return this.state.selectedTags.every((tag) =>
        tagIds.includes(Number(tag.value))
      );
    });

    const leadsWithTags = filteredLeads.map((lead) => {
      const tagIds = lead.tag_id ? lead.tag_id.split(",") : [];

      const tagNames = tagIds.map((tagId) => {
        const tag = this.tags.find((tag) => tag.id == tagId);
        return tag ? tag.tag : null;
      });

      const origineTags = [];
      const corsoTags = [];
      const infoDateTags = [];

      tagIds.forEach((tagId) => {
        const tag = this.tags.find((tag) => tag.id == tagId);
        if (tag) {
          const categoria = this.category.find(
            (categoria) => categoria.id == tag.id_categoria
          );
          if (categoria) {
            if (categoria.nome === "ORIGINE") {
              origineTags.push(tag.tag);
            } else if (categoria.nome === "CORSO") {
              corsoTags.push(tag.tag);
            } else if (categoria.nome === "INFO DATE") {
              infoDateTags.push(tag.tag);
            }
          }
        }
      });

      const dateOnly = lead.data_creazione
        ? lead.data_creazione.split(" ")[0]
        : "";
      const dataIscrizioneFormatted = lead.data_iscrizione
        ? lead.data_iscrizione.split(" ")[0]
        : "";

      return {
        ...lead,
        tag_name: tagNames.length > 0 ? tagNames.join(", ") : "Nessun tag",
        origine: origineTags.length > 0 ? origineTags.join(", ") : "",
        corso: corsoTags.length > 0 ? corsoTags.join(", ") : "",
        info_date: infoDateTags.length > 0 ? infoDateTags.join(", ") : "",
        data_creazione: dateOnly,
        data_iscrizione: dataIscrizioneFormatted,
      };
    });

    this.setState({
      leads: leadsWithTags,
    });
  }

  async componentDidMount() {
    await this.reload();
  }

  // Segna tutti i lead come visti
  markAllAsRead = async () => {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });

    const unreadLeads = this.state.leads.filter(
      (lead) => lead.visto === 0 || lead.visto === "0"
    );

    if (unreadLeads.length === 0) {
      alert("Non ci sono lead non visti da segnare.");
      return;
    }

    if (
      window.confirm(`Vuoi segnare ${unreadLeads.length} lead come visti?`) ===
      false
    ) {
      return;
    }

    try {
      await setLeadVisto(username, token, null, null, true);
      this.context.updateLeadsCount(0);
      await this.reload();
    } catch (error) {
      console.error("Errore nel segnare tutti come visti:", error);
      alert("Errore nel segnare tutti come visti.");
    }
  };

  // Segna un singolo lead come visto
  markLeadAsRead = async (leadId) => {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });

    try {
      const result = await setLeadVisto(username, token, leadId);
      if (result && result.success) {
        this.context.updateLeadsCount((prev) => (prev > 0 ? prev - 1 : 0));
        // Aggiorna lo stato locale senza ricaricare tutto
        this.setState((prevState) => ({
          leads: prevState.leads.map((lead) =>
            lead.id === leadId ? { ...lead, visto: 1 } : lead
          ),
        }));
      }
    } catch (error) {
      console.error("Errore nel segnare come visto:", error);
    }
  };

  render() {
    var headCells = [
      {
        id: "data_creazione",
        numeric: false,
        disablePadding: false,
        label: "Data creazione",
      },
      { id: "nome", numeric: false, disablePadding: true, label: "Nome" },
      { id: "cognome", numeric: true, disablePadding: false, label: "Cognome" },
      {
        id: "telefono",
        numeric: true,
        disablePadding: false,
        label: "Telefono",
      },
      { id: "corso", numeric: true, disablePadding: false, label: "Corso" },
      { id: "origine", numeric: true, disablePadding: false, label: "Origine" },
      {
        id: "data_iscrizione",
        numeric: true,
        disablePadding: false,
        label: "Data iscrizione",
      },
      {
        id: "prenotazione",
        numeric: true,
        disablePadding: false,
        label: "Prenotazione",
      },
      { id: "_", numeric: true, disablePadding: false, label: "" },
    ];

    this.searchCols = [
      "nome",
      "cognome",
      "mail",
      "telefono",
      "corso",
      "origine",
      "data_creazione",
      "data_iscrizione",
      "prenotazione",
    ];

    const cookies = new Cookies();

    const formattedTags = this.tags.map((tag) => ({
      value: tag.id,
      label: tag.tag,
    }));

    return (
      <>
        <LoadingOverlay
          active={this.state.isLoading}
          styles={{
            content: (base) => ({
              position: "relative",
              width: "100%",
              top: "200px",
            }),
          }}
          spinner
          text={"Loading your content..."}
        >
          <PageTitle
            title={this.pageTitle}
            button="NUOVO"
            secondButton="SEGNA VISTI"
            onClick={() => {
              window.location.href = "/#/app/addLead";
            }}
            onSecondClick={this.markAllAsRead}
          />

          <Table
            storageKey="daChiamare_table"
            headCells={headCells}
            searchCols={this.searchCols}
            desc
            assenze={false}
            calendar={false}
            onChangeCategoria={this.handleCategoriaChange}
            onChangeCorsi={this.handleCorsiChange}
            onChangeDataInizio={this.handleDataInizioChange}
            onChangeDataFine={this.handleDataFineChange}
            dataInizio={this.state.dataInizio}
            dataFine={this.state.dataFine}
            filterTags={formattedTags}
            handleTagChange={this.handleTagChange}
            removeTags
            handleTagRemoveChange={this.handleTagRemoveChange}
            selectedTags={this.state.selectedTags}
            excludedTags={this.state.excludedTags}
            onResetFilters={this.handleResetFilters}
            pdf={false}
            excel={false}
            mail={false}
            phone={false}
            rows={this.state.leads}
            onEventClick={async (row) => {
              // Segna il lead come visto se non lo è già
              if (row.visto === 0 || row.visto === "0") {
                await this.markLeadAsRead(row.id);
              }
              cookies.set("currentCrm", row, { path: "/" });
              window.location.href = "/#/app/editLead";
            }}
            onPdfClicked={(row) => {
              cookies.set("requestedStudent", row, { path: "/" });
              window.location.href = "/#/app/pdfSingleStudent";
            }}
            onSendMail={(id) => {
              this.sendMailRef.current && this.sendMailRef.current.reset();
              this.setState({ sendMailVisible: true, sendMailUserId: id });
            }}
            onSendNotification={(id) => {
              this.sendNotificationRef.current &&
                this.sendNotificationRef.current.reset();
              this.setState({
                sendNotificationVisible: true,
                notificationUser: id,
              });
            }}
            onDelete={async (id) => {
              if (
                window.confirm("Sei sicuro di voler eliminare il lead?") ==
                false
              )
                return;

              const cookies = new Cookies();
              const username = cookies.get("username", { path: "/" });
              const token = cookies.get("token", { path: "/" });
              await deleteLeads(username, token, id);
              this.reload();
            }}
            onElementCheck={async (companyId) => {
              const cookies = new Cookies();

              var json = cookies.get("checksList", { path: "/" });
              var checksList = json.list;
              var index = checksList.indexOf(companyId);
              if (index != -1) checksList.splice(index, 1);
              else checksList.push(companyId);

              cookies.set("checksList", JSON.stringify({ list: checksList }), {
                path: "/",
              });
            }}
          />

          <WaitDialog
            show={this.state.waitDialogVisible}
            key={Math.random()}
            index={this.state.index}
          />
        </LoadingOverlay>
      </>
    );
  }
}
